export enum USER_ROLE_TYPES {
  ADMIN = 'admin',
  USER = 'user',
  OWNER = 'owner',
  GROUP_LEADER = 'group_lead',
}
